module.exports = __webpack_public_path__ + "img/personal.e3dc5a7a.svg";